<template>
  <header class="header">
    <div class="container container--relative">
      <div class="header__logo" :class="`header__logo--${language}`"></div>
      <div class="header__languages header-languages">
        <div
            v-for="(lang, i) in languages" :key="i"
            @click="changeLanguage(lang)"
            class="header-languages__language"
            :class="[
            `header-languages__language--${lang}`,
            language === lang ? 'header-languages__language--active' : '',
          ]"></div>
      </div>
    </div>
  </header>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'the-header',

    data: () => ({
    }),

    computed: {
      ...mapGetters(['languages', 'language']),
    },

    methods: {
      changeLanguage(lang) {
        this.$i18n.locale = lang;
        this.$store.dispatch('changeLanguage', lang);
      },
    },
  }
</script>
